import { render, staticRenderFns } from "./BusinessLeadCreditApplication.vue?vue&type=template&id=10245188&scoped=true&"
import script from "./BusinessLeadCreditApplication.vue?vue&type=script&lang=js&"
export * from "./BusinessLeadCreditApplication.vue?vue&type=script&lang=js&"
import style0 from "./BusinessLeadCreditApplication.vue?vue&type=style&index=0&id=10245188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10245188",
  null
  
)

export default component.exports